module.exports = __webpack_public_path__ + "img/honor9.1683d89e.png";